import { translate, useLocale } from "../../localization";
import { Link } from "react-router-dom";
import "./PricingLink.scss";

const ContactLink = ({ }) => {
  useLocale();
  return(
    <Link className="header-link" to="/contact">{translate("Contact")}</Link>
  )
}

export default ContactLink;